import { ExpandLess, ExpandMore, MoreVert, Search, ViewColumn } from "@mui/icons-material";
import { Button, Card, CardContent, Checkbox, Container, Divider, IconButton, InputAdornment, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover, TextField } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { setBreadcumbs, setIsShowBack, setTitle } from "../../../containers/containers.reducer";
import CustomModal from "../../../shared/CustomModal";
import notificationError from "../../../shared/notificationError";
import notificationSuccess from "../../../shared/notificationSuccess";
import { deleteProject, getProjectListWithPaginations } from "../project.api";
import JobNumberAdd from "./detail/JobNumberAdd";
import ProjectEdit from "./ProjectEdit";

export default function Project() {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [popAnchorShowColumn, setPopAnchorShowColumn] = useState<HTMLButtonElement | null>(null);
    const [popAnchorAction, setPopAnchorAction] = useState<HTMLButtonElement | null>(null);
    const [columnHidden, setColumnHidden] = useState<any>([])
    const [dataList, setDataList] = useState<any>([])
    const [dataSelected, setDataSelected] = useState<any>({})
    const [modalEdit, setModalEdit] = useState(false)
    const [modalAddChild, setModalAddChild] = useState(false)
    const [expandedIds, setExpandedIds] = useState<any>([])
    const [searchWord, setSearchWord] = useState("")

    const handleExpand = (id: string) => {
        if (expandedIds.includes(id)) {
            setExpandedIds(expandedIds.filter((ids: string) => ids !== id))
        }
        else {
            setExpandedIds([...expandedIds, id])
        }
    }

    const columns = [
        {
            name: "Project",
            customRender: (props: any) => {
                return (
                    <td>
                        <IconButton onClick={() => handleExpand(props.data.id)}>
                            {expandedIds.includes(props.data.id) ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                        <span className="clickable" onClick={() => navigate('/project/detail?id=' + props.data.id)}>
                            <Link underline="always">{props.data.name}</Link>
                        </span>
                    </td>
                )
            }
        },
        {
            name: "Requestor",
            key: "requestor_name"
        },
        {
            name: "Submittal",
            key: "submittal_name"
        },
        {
            name: "District",
            key: "district_name"
        }
    ]

    useEffect(() => {
        dispatch(setTitle("Project"))
        dispatch(setIsShowBack(false))
        dispatch(setBreadcumbs([
            {
                name: "Project",
                url: "/project"
            }
        ]))
    }, [])

    useEffect(() => {
        getDataList()
    }, [])

    const getDataList = () => {
        dispatch<any>(getProjectListWithPaginations({
            search: searchWord
        }))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    setDataList(response.data.data)
                }
                else {
                    notificationError(response)
                }
            })
    }

    const handleChangeColumnHidden = (e: any, name: String) => {
        if (e.target.checked) {
            setColumnHidden(columnHidden.filter((item: String) => item !== name))
        }
        else {
            setColumnHidden([...columnHidden, name])
        }
    }

    const handleDelete = () => {
        Swal.fire({
            icon: "question",
            title: "Are you sure to delete this data?",
            showCancelButton: true
        })
            .then(response => {
                if (response.isConfirmed) {
                    dispatch<any>(deleteProject(dataSelected.id))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                notificationSuccess("success delete project")
                                setPopAnchorAction(null)
                                getDataList()
                            }
                            else {
                                notificationError(response)
                            }
                        })
                }
            })
    }

    const handleCloseModalEdit = (isReload: boolean) => {
        setModalEdit(false)
        if (isReload) {
            getDataList()
        }
        setPopAnchorAction(null)
    }

    const handleCloseModalAddChild = (isReload: boolean) => {
        setModalAddChild(false)
        if (isReload) {
            getDataList()
        }
        setPopAnchorAction(null)
    }

    const handleChangeSearch = (e: any) => {
        let { value } = e.target
        setSearchWord(value)
    }

    const handleSearch = (e: any) => {
        e.preventDefault()
        getDataList()
    }

    return (
        <Container className="project">
            <Popover
                open={Boolean(popAnchorShowColumn)}
                anchorEl={popAnchorShowColumn}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                onClose={() => setPopAnchorShowColumn(null)}
            >
                <List>
                    {columns.map((column: any, i: number) => (
                        <ListItem
                            key={i}
                            disablePadding
                            style={{ paddingRight: 20 }}
                        >
                            <ListItemIcon>
                                <Checkbox
                                    checked={!columnHidden.includes(column.name)}
                                    onChange={e => handleChangeColumnHidden(e, column.name)}
                                />
                            </ListItemIcon>
                            <ListItemText>{column.name}</ListItemText>
                        </ListItem>
                    ))}
                </List>
            </Popover>
            <Popover
                open={Boolean(popAnchorAction)}
                anchorEl={popAnchorAction}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                onClose={() => setPopAnchorAction(null)}
            >
                <List>
                    <ListItemButton onClick={() => setModalEdit(true)}>
                        <ListItemText>Edit Project</ListItemText>
                    </ListItemButton>
                    <ListItemButton onClick={() => setModalAddChild(true)}>
                        <ListItemText>Add Job Number</ListItemText>
                    </ListItemButton>
                    <ListItemButton onClick={handleDelete}>
                        <ListItemText>Delete Project</ListItemText>
                    </ListItemButton>
                </List>
            </Popover>
            <CustomModal
                open={modalEdit}
                onClose={handleCloseModalEdit}
                title="Edit Project"
                component={
                    <ProjectEdit onClose={handleCloseModalEdit} data={dataSelected} />
                }
            />
            <CustomModal
                open={modalAddChild}
                onClose={handleCloseModalAddChild}
                title="Add Job Number"
                component={
                    <JobNumberAdd onClose={handleCloseModalAddChild} data={dataSelected} />
                }
            />
            <Card variant="outlined">
                <CardContent className="custom-table-container">
                    <div className="header">
                        <div>
                            <Button
                                variant="contained"
                                startIcon={<ViewColumn />}
                                endIcon={<ExpandMore />}
                                color="secondary"
                                onClick={e => setPopAnchorShowColumn(e.currentTarget)}
                            >
                                Column Shown
                            </Button>
                            <form onSubmit={handleSearch}>
                                <TextField
                                    className="inp"
                                    size="small"
                                    variant="outlined"
                                    onChange={handleChangeSearch}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start"><Search color="primary" /></InputAdornment>,
                                    }}
                                    placeholder="Type and enter for search"
                                />
                                <button type="submit" hidden={true} />
                            </form>
                        </div>
                        <div>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/project/add')}
                            >
                                New Project
                            </Button>
                        </div>
                    </div>
                    <Divider />
                    <div className="body">
                        <table>
                            <thead>
                                <tr>
                                    {columns.map((column: any, i: number) => (
                                        !columnHidden.includes(column.name) && <td key={i}>{column.name}</td>
                                    ))}
                                    <td>
                                        Action
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {dataList.map((data: any, i: number) => {
                                    let configList = data.config_list ? JSON.parse(data.config_list) : []
                                    return (
                                        <Fragment key={data.id}>
                                            <tr className={i % 2 ? "" : "odd"}>
                                                {columns.map((column: any, j: number) => (
                                                    !columnHidden.includes(column.name) && (
                                                        column.key
                                                            ? <td key={j}>{data[column.key]}</td>
                                                            : <column.customRender key={j} data={data} />

                                                    )
                                                ))}
                                                <td>
                                                    <IconButton onClick={e => { setPopAnchorAction(e.currentTarget); setDataSelected(data) }}>
                                                        <MoreVert />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                            <tr hidden={!expandedIds.includes(data.id)} className={i % 2 ? "" : "odd"}>
                                                <td colSpan={5}>
                                                    <table>
                                                        <tbody>
                                                            {configList.map((config: any, j: number) => (
                                                                <tr>
                                                                    <td>
                                                                        <b>KOJ</b>
                                                                        <br />
                                                                        <span style={{ backgroundColor: config.koj_color }}>{config.koj_name}</span>
                                                                    </td>
                                                                    <td>
                                                                        <b>Type</b>
                                                                        <br />
                                                                        <span>{config.type_job_name}</span>
                                                                    </td>
                                                                    <td>
                                                                        <b>Target</b>
                                                                        <br />
                                                                        <span>{config.target}</span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </Fragment>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </CardContent>
            </Card>
        </Container >
    )
}